import React from 'react';
import { withStyles } from "@mui/styles";
import { Grid, Typography } from '@mui/material';


import en from "../../i18n/English/Policies/rights(cdsl).json";
import hi from "../../i18n/Hindi/Policies/rights(cdsl).json";
import kn from "../../i18n/Kannada/Policies/rights(cdsl).json";
import ma from "../../i18n/Marathi/Policies/rights(cdsl).json";
import gu from "../../i18n/Gujarati/Policies/rights(cdsl).json";
import { useLanguage } from "../../Context/LangContext";
import DocumentMeta from 'react-document-meta'
const styles = theme => ({
    heading: {
        textTransform: 'none !important',
        color: '#000000 !important',
        fontFamily: 'Inter500 !important',
        fontSize: 'calc(24px + var(--font-delta)) !important',
        marginBlockStart: 0,
        marginBlockEnd: 0,
        fontWeight: 'normal',
        "@media only screen and (max-device-width: 480px)": {

            fontFamily: 'Inter400 !important',
            fontSize: 'calc(20px + var(--font-delta)) !important',
        }
    },
    p_body: {
        textTransform: 'none !important',
        color: '#000000 !important',
        fontFamily: 'Inter400 !important',
        fontSize: 'calc(16px + var(--font-delta)) !important',
        lineHeight: "22px !important",
        "@media only screen and (max-device-width: 480px)": {

            fontFamily: 'Inter400 !important',
            fontSize: 'calc(14px + var(--font-delta)) !important',
            lineHeight: "20px !important",
        }
    },
})
const meta = {
    title: 'CDSL Rights & Obligations | Secure Demat Trading | TradeBoss',
    description: 'Know your CDSL rights & obligations with TradeBoss. Ensure compliant, transparent demat account management & safe NSE, BSE trading.',
    canonical: 'https://tradeboss.co/cdsl',
    meta: {
        charset: 'utf-8',
        name: {
            keywords: 'CDSL rights and obligations, demat account CDSL rules, rights of demat holder CDSL, CDSL compliance, using CDSL demat services'
        }
    }
}
const Cdsl = ({ classes }) => {


    const { language } = useLanguage();
              const translations = { en, hi, kn,ma,gu };
              const t = translations[language];
    return (
        <div style={{ height: 'auto', padding: '0px 0px 20px 0px' }}>
            <DocumentMeta {...meta} />
            <Grid style={{ padding: '20px 0px 40px 0px' }}>
                <h1 className={classes.heading} style={{
                    textAlign: 'center', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                 }}>
                    {t.title}
                </h1>

                <Typography className={classes.p_body} style={{
                    padding: '20px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                  }}>
                    {t.sections[0].points[0]}
                </Typography>

                <Typography className={classes.p_body} style={{
                    padding: '20px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }}>
                    {t.sections[0].points[1]}
                </Typography>

                <h1 className={classes.heading} style={{
                    padding: '20px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }}>
                    {t.sections[1].heading}
                </h1>

                <Typography className={classes.p_body} style={{
                    padding: '20px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }}>
                    {t.sections[1].points[0]}
                </Typography>

                <Typography className={classes.p_body} style={{
                    padding: '20px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }}>
                    {t.sections[1].points[1]}
                </Typography>

                <h1 className={classes.heading} style={{ padding: '20px 0px 0px 0px' }}>
                    {t.sections[2].heading}
                </h1>

                <Typography className={classes.p_body} style={{
                    padding: '20px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }}>
                    {t.sections[2].points[0]}
                </Typography>

                <Typography className={classes.p_body} style={{
                    padding: '20px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }}>
                    {t.sections[2].points[1]}
                </Typography>

                <Typography className={classes.p_body} style={{
                    padding: '20px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }}>
                    {t.sections[2].points[2]}
                </Typography>

                <h1 className={classes.heading} style={{ padding: '20px 0px 0px 0px' }}>
                    {t.sections[3].heading}
                </h1>

                <Typography className={classes.p_body} style={{
                    padding: '20px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }}>
                    {t.sections[3].points[0]}
                </Typography>

                <h1 className={classes.heading} style={{ padding: '20px 0px 0px 0px' }}>
                    {t.sections[4].heading}
                </h1>

                <Typography className={classes.p_body} style={{
                    padding: '20px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }}>
                    {t.sections[4].points[0]}
                </Typography>

                <Typography className={classes.p_body} style={{
                    padding: '20px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }}>
                    {t.sections[4].points[1]}
                </Typography>

                <h1 className={classes.heading} style={{ padding: '20px 0px 0px 0px' }}>
                    {t.sections[5].heading}
                </h1>

                <Typography className={classes.p_body} style={{
                    padding: '20px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }}>
                    {t.sections[5].points[0]}
                </Typography>

                <Typography className={classes.p_body} style={{
                    padding: '20px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }}>
                    {t.sections[5].points[1]}
                </Typography>

                 <Typography className={classes.p_body} style={{
                    padding: '20px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }}>
                    {t.sections[5].points[2]}
                </Typography>

                <h1 className={classes.heading} style={{ padding: '20px 0px 0px 0px' }}>
                    {t.sections[6].heading}
                </h1>

                <Typography className={classes.p_body} style={{
                    padding: '20px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }}>
                    {t.sections[6].points[0]}
                </Typography>

                <Typography className={classes.p_body} style={{
                    padding: '20px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }}>
                    {t.sections[6].points[1]}
                </Typography>

                <Typography className={classes.p_body} style={{
                    padding: '20px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }}>
                    {t.sections[6].points[2]}
                </Typography>

                <Typography className={classes.p_body} style={{
                    padding: '20px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }}>
                    {t.sections[6].points[3]}
                </Typography>

                <h1 className={classes.heading} style={{ padding: '20px 0px 0px 0px' }}>
                    {t.sections[7].heading}
                </h1>

                <Typography className={classes.p_body} style={{
                    padding: '20px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }}>
                    {t.sections[7].points[0]}
                </Typography>

                <Typography className={classes.p_body} style={{
                    padding: '20px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }}>
                    {t.sections[7].points[1]}

                </Typography>

                <h1 className={classes.heading} style={{ padding: '20px 0px 0px 0px' }}>
                    {t.sections[8].heading}
                </h1>

                <Typography className={classes.p_body} style={{
                    padding: '20px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }}>
                    {t.sections[8].points[0]}
                </Typography>

                <Typography className={classes.p_body} style={{
                    padding: '20px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }}>
                    {t.sections[8].points[1]}
                </Typography>

                <h1 className={classes.heading} style={{
                    padding: '20px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }}>
                    {t.sections[9].heading}
                </h1>

                <Typography className={classes.p_body} style={{
                    padding: '20px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }}>
                    {t.sections[9].points[0]}
                </Typography>

                <h1 className={classes.heading} style={{
                    padding: '20px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }}>
                    {t.sections[10].heading}
                </h1>

                <Typography className={classes.p_body} style={{
                    padding: '20px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }}>
                    {t.sections[10].points[0]}
                </Typography>

                <Typography className={classes.p_body} style={{
                    padding: '20px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }}>
                    {t.sections[10].points[1]}
                </Typography>

                   <Typography className={classes.p_body} style={{
                    padding: '20px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }}>
                    {t.sections[10].points[2]}
                </Typography>

                   <Typography className={classes.p_body} style={{
                    padding: '20px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }}>
                    {t.sections[10].points[3]}
                </Typography>

                <h1 className={classes.heading} style={{ padding: '20px 0px 0px 0px' }}>
                    {t.sections[11].heading}
                </h1>

                <Typography className={classes.p_body} style={{
                    padding: '20px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }}>
                    {t.sections[11].points[0]}
                </Typography>

                <h1 className={classes.heading} style={{ padding: '20px 0px 0px 0px' }}>
                    {t.sections[12].heading}
                </h1>

                <Typography className={classes.p_body} style={{
                    padding: '20px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                }}>
                    {t.sections[12].points[0]}
                </Typography>

                <Typography className={classes.p_body} style={{
                    padding: '20px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }}>
                    {t.sections[12].points[1]}
                </Typography>

                <Typography className={classes.p_body} style={{
                    padding: '20px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }}>
                    {t.sections[12].points[2]}
                </Typography>

                <Typography className={classes.p_body} style={{
                    padding: '20px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }}>
                    {t.sections[12].points[3]}
                </Typography>

                <Typography className={classes.p_body} style={{
                    padding: '20px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }}>
                    {t.sections[12].points[4]}
                </Typography>

                <Typography className={classes.p_body} style={{
                    padding: '20px 0px 0px 0px', whiteSpace: "normal",
                    textAlign: "justify",
                    lineHeight: "1.5"
                    }}>
                    {t.sections[12].points[5]}
                </Typography>
            </Grid>
        </div>
    );
}

export default withStyles(styles)(Cdsl);